/**
 * bridge模块
 * 1.bridge: 目前都是用fusion
 * 2.dbridge: driver-bridge
 * 3.kfdbridge: kf-driver-bridge
 */
export { fusionBridge as bridge, dbridge, kfdbridge, esappBridge, hydriverBridge, alimpReady, alipayReady, mqqReady, weixinmpReady, weixinReady } from './xenv/_common';
